module.exports = __webpack_public_path__ + "img/DerAufprall1.e3b08303.jpg";